import { render, staticRenderFns } from "./BandsIntro.vue?vue&type=template&id=7dafaa04&scoped=true"
import script from "./BandsIntro.vue?vue&type=script&lang=js"
export * from "./BandsIntro.vue?vue&type=script&lang=js"
import style0 from "./BandsIntro.vue?vue&type=style&index=0&id=7dafaa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafaa04",
  null
  
)

export default component.exports